@let s = stat();

<div
  (click)="clickAction()()"
  class="card mat-padding-1"
  [ngClass]="{ pointer: s.click, canClick: s.click }"
  fxLayout="row"
  fxLayoutGap="16px"
>
  <div fxFlex>
    <div class="mat-h4">
      {{ s.title }}
      @if (s.tooltip) {
      <span nz-tooltip [nzTooltipTitle]="s.tooltip">
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
      </span>
      }
    </div>
    <div class="mat-h1">
      {{ s.sum }}
    </div>

    <div class="mat-caption">
      @if (s.efficiency) {
      {{ s.efficiency }}
      } @else { &nbsp;}
    </div>
  </div>

  @if(s.icon) {
  <div class="">
    <img height="24" [src]="'/assets/icons/dashboard/' + s.icon + '.svg'" />
  </div>
  }
</div>
